import React from "react";
import "./AboutVaranous.css";
import Aboutus from "../../assets/About/AboutUsImage.jpg";
import about2 from "../../assets/About/about2.jpg";
import Light from "../../assets/About/Light.webp";
import sys from "../../assets/About/sys.jpg";
import Footer from "../Footer/Footer";

const AboutVaranous = () => {
  return (
    <div className="about-container">
      {/* Banner Section */}
      <div className="banner-wrapper">
        <img src={Aboutus} alt="About Varanous" className="banner-image" />
        <div className="banner-text">
          <h1>About Us</h1>
        </div>
      </div>

      {/* Cards Section */}
      <div className="about-section12">
        <div className="about-cards">
          <div className="card">
            <img src={about2} alt="About Varanous" />
            <div className="card-content">
              <h3>Welcome to Varanous Labs</h3>
              <p>
                Varanous Labs Pvt Ltd is a premium contract research organization
                providing cost-effective chemistry solutions to global customers
                of diverse origin varying from Pharmaceutical, Agrochemicals,
                Biotech companies, and Academic Researchers. Our values are
                Respect, Team effort, Transparency, Integrity, Confidentiality,
                and Safety. We are a socially responsible and environmentally
                conscious research organization.
              </p>
            </div>
          </div>

          <div className="card">
            <img src={Light} alt="Our Mission" />
            <div className="card-content">
              <h3>Our Mission</h3>
              <p>
                To become a value-added R&D support organization for their generic
                product development needs at various platforms. Varanous is
                committed to quality research products & services delivery to
                comply with project needs in a timely, confidential, and
                cost-effective manner. We firmly believe that developing
                long-term relationships with our clients should be prioritized
                ahead of short-term goals.
              </p>
            </div>
          </div>

          <div className="card">
            <img src={sys} alt="Key Differentiator" />
            <div className="card-content">
              <h3>Key Differentiator</h3>
              <ul>
                <li>100000 Sq. Feet own state-of-art research facility</li>
                <li>15000+ products from 1000 API</li>
                <li>350+ Qualified technical team</li>
                <li>Certified COA, IR, Mass, HPLC, NMR, TGA & ROI</li>
                <li>In-house capability performing all analytical tests</li>
                <li>USP/EP traceable products on demand</li>
                <li>Uncompromised quality</li>
                <li>Extensive technical support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutVaranous;
